export const DEMANDE_SEJOUR_STATUTS = {
  ABANDONNEE: "ABANDONNEE",
  ANNULEE: "ANNULEE",
  ATTENTE_8_JOUR: "EN ATTENTE DECLARATION 8 JOURS",
  A_MODIFIER: "A MODIFIER",
  A_MODIFIER_8J: "A MODIFIER 8J",
  BROUILLON: "BROUILLON",
  EN_COURS: "EN COURS",
  EN_COURS_8J: "EN COURS 8J",
  REFUSEE: "REFUSEE",
  REFUSEE_8J: "REFUSEE 8J",
  SEJOUR_EN_COURS: "SEJOUR EN COURS",
  TERMINEE: "TERMINEE",
  TRANSMISE: "TRANSMISE",
  TRANSMISE_8J: "TRANSMISE 8J",
  VALIDEE_8J: "VALIDEE 8J",
};

export const STATUS_USER_FRONT = {
  BLOCKED: "BLOCKED",
  NEED_EMAIL_VALIDATION: "NEED_EMAIL_VALIDATION",
  NEED_SIRET_VALIDATION: "NEED_SIRET_VALIDATION",
  TEMPORARY_BLOCKED: "TEMPORARY_BLOCKED",
  VALIDATED: "VALIDATED",
} as const;
